module.exports = __webpack_public_path__ + "static/img/bim12.2297c02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/bim12.png
// module id = lbeC
// module chunks = 17